import { render } from "../templates/modal-status.html?vue&type=template&id=3541d989"
import script from "./modal-status.vue?vue&type=script&lang=js"
export * from "./modal-status.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__